import styles from './MarketplacePageHeader.module.scss'
import type { MarketplacePageHeaderProps } from './MarketplacePageHeader.types'

export const MarketplacePageHeader = ({
  title,
  subtitle,
  children
}: MarketplacePageHeaderProps) => (
  <header className={styles.header}>
    <div className={styles.heading}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
    {children && <div className={styles.actions}>{children}</div>}
  </header>
)
